import { useLingui } from '@lingui/react/macro';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@worldcoo/ui/components/accordion';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@worldcoo/ui/components/dialog';
import { useLocation } from '@tanstack/react-router';
import { useFaqCategories } from './faq-data';
import { MessageQuestionIcon } from './assets/sidebar-icons';

function useCurrentFaqCategory() {
	const pathname = useLocation({ select: (l) => l.pathname });
	if (pathname.startsWith('/ngos/dashboard')) return 'results';
	if (pathname.startsWith('/ngos/projects')) return 'projects';
	if (pathname.startsWith('/ngos/portals')) return 'portals';
	if (pathname.startsWith('/ngos/settings')) return 'settings';
	return null;
}

export function FaqPopup() {
	const { t } = useLingui();
	const faqCategories = useFaqCategories();
	const currentCategoryId = useCurrentFaqCategory();
	if (!currentCategoryId) return null;
	const items = faqCategories.find((c) => c.id === currentCategoryId)?.items;
	if (!items?.length) return null;

	return (
		<Dialog modal={false}>
			<DialogTrigger asChild>
				<button
					type="button"
					className="border-portal-border fixed right-4 bottom-4 z-50 flex size-12 items-center justify-center rounded-full border bg-white shadow-[0px_8px_24px_0px_rgba(77,33,0,0.05)] md:right-6.5 md:bottom-6.5 md:size-[56px]"
				>
					<MessageQuestionIcon className="size-5 text-[#35433f] md:size-6" />
				</button>
			</DialogTrigger>

			<DialogContent
				className="data-closed:zoom-out-95 data-closed:slide-out-to-bottom-2 data-closed:slide-out-to-right-2 data-open:zoom-in-95 data-open:slide-in-from-bottom-2 data-open:slide-in-from-right-2 top-auto right-2 bottom-20 left-2 z-40 max-h-[80vh] w-auto max-w-[472px] origin-bottom-right translate-0 overflow-y-auto rounded-2xl p-5 shadow-[0px_8px_24px_0px_rgba(77,33,0,0.05)] md:right-[54px] md:bottom-[54px] md:left-auto md:p-8"
				aria-describedby={undefined}
			>
				<DialogTitle className="text-xl font-medium tracking-[-0.2px] text-[#35433f]">
					{t`Frequently Asked Questions`}
				</DialogTitle>

				<Accordion type="single" collapsible defaultValue={items[0]?.question} className="flex flex-col gap-3">
					{items.map((item, index) => (
						<AccordionItem
							key={item.question}
							value={item.question}
							className={index < items.length - 1 ? 'border-b pb-3' : 'border-none'}
						>
							<AccordionTrigger className="py-0 pb-2 text-base leading-[1.5] font-medium tracking-[-0.2px] text-[#35433f] no-underline hover:no-underline [&>svg]:size-6 [&>svg]:text-[#35433f]">
								{item.question}
							</AccordionTrigger>
							<AccordionContent className="text-sm leading-[1.5] text-[#666]">{item.answer}</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			</DialogContent>
		</Dialog>
	);
}
